import {
    FinancialAccount,
    FinancialAccountSourceType,
} from "@common/types/financialAccount";
import { Amount } from "@design-system/Amount/Amount";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { SelectableItem } from "@design-system/SelectableItem/SelectableItem";
import { HStack } from "@design-system/HStack/HStack";
import { ArrowRightIcon } from "@icons";
import { AccountInstitutionIcon } from "@components/institution/AccountInstitutionIcon";

interface Props {
    invoicingAccounts?: FinancialAccount[];
    show: boolean;
    onHide: () => void;
    onSelect: (account: FinancialAccount) => void;
}

function getAccountTitle(account: FinancialAccount): string {
    if (account.sourceType === FinancialAccountSourceType.BILLCOM) {
        return "Bill";
    }
    return account.name ?? "";
}

function getAccountDescription(account: FinancialAccount): React.ReactNode {
    if (account.sourceType === FinancialAccountSourceType.BILLCOM) {
        return <span>{account.name}</span>;
    }
    return (
        <HStack gap={8} align="center">
            {account.balance && (
                <Amount amount={account.balance} separateCurrencySign />
            )}
            <span>{account.integrationAccounts?.[0]?.sourceAccountId}</span>
        </HStack>
    );
}

export const AccountSelectModal: React.FC<Props> = ({
    show,
    onHide,
    invoicingAccounts,
    onSelect,
}) => (
    <StandardModal show={show} onHide={onHide}>
        <StandardModalHeader>Select account</StandardModalHeader>
        <StandardModalBody>
            {invoicingAccounts?.map((account) => (
                <SelectableItem
                    key={account.id}
                    title={getAccountTitle(account)}
                    onSelect={() => onSelect(account)}
                    icon={
                        <AccountInstitutionIcon account={account} size="lg" />
                    }
                    description={getAccountDescription(account)}
                >
                    <ArrowRightIcon aria-hidden="true" />
                </SelectableItem>
            ))}
        </StandardModalBody>
    </StandardModal>
);
